import React from "react";

import { splitPrice } from "@utils/productPrice";

import "./productPrice.scss";

type Props = {
    price: number;
    variant?: "default" | "promo";
    size?: "default" | "medium" | "large";
    conversionUnit?: string | null;
    conversionPriceActive?: boolean;
};

const DefaultPrice = ({
    price,
    size,
    conversionPriceActive = false,
    conversionUnit,
}: Props) => {
    if (price != null) {
        const splitted = splitPrice(price);

        return (
            <span
                className={`price--${size || "default"}`}
                data-test="productLayoutPrice"
            >
                {splitted[0]},
                <span
                    className={
                        size === "default"
                            ? "price--default--decimal"
                            : "price--large--decimal"
                    }
                >
                    {conversionPriceActive
                        ? `${
                              splitted[1] === "00" ? "-" : splitted[1]
                          }/${conversionUnit}`
                        : splitted[1] === "00"
                        ? "-"
                        : splitted[1]}
                </span>
            </span>
        );
    } else {
        return null;
    }
};

/**
 * PromoPrice
 */
const PromoPrice = ({
    price,
    size,
    conversionPriceActive = false,
    conversionUnit,
}: Props) => {
    if (price != null) {
        const splitted = splitPrice(price);

        return (
            <span
                className={"price--promo"}
                style={size !== "default" ? { fontSize: "1em" } : {}}
            >
                {conversionPriceActive
                    ? `${splitted[0]},${
                          splitted[1] === "00" ? "-" : splitted[1]
                      }/${conversionUnit}`
                    : `${splitted[0]},${
                          splitted[1] === "00" ? "-" : splitted[1]
                      }`}
            </span>
        );
    } else {
        return null;
    }
};

/**
 * ProductPrice
 */
const ProductPrice = ({
    price,
    variant = "default",
    size = "default",
    conversionUnit,
    conversionPriceActive = false,
}: Props) => (
    <React.Fragment>
        {variant === "default" ? (
            <DefaultPrice
                price={price}
                size={size}
                conversionPriceActive={conversionPriceActive}
                conversionUnit={conversionUnit}
            />
        ) : (
            <PromoPrice
                price={price}
                size={size}
                conversionPriceActive={conversionPriceActive}
                conversionUnit={conversionUnit}
            />
        )}
    </React.Fragment>
);

export { ProductPrice };
